<template>
    <div class="app-body row app-main-component">
        
        <!--
        <div class="d-none d-md-inline col-md-4 col-lg-4 col-xl-3 header-col app-body-left" align="justify">

            <div class="">
                <ul id="main-menu" class="nav flex-column d-none d-md-block">
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/'">Главная</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/о-предприятии'">О предприятии</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/важная-информация'">Важная информация</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/закупки'">Закупки</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/тарифы'">Тарифы</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/стандарты-раскрытия-информации'">Стандарты раскрытия информации</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/фотографии'">Фотографии</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/новости'">Новости</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/контактная-информация'">Контактная информация</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" v-bind:to="httpPath + '/режим-работы'">Режим работы</router-link></li>
                </ul>
            </div>

        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9 header-col app-body-right" align="justify">
            <router-view></router-view>
        </div>
        -->

        <div class="col-12 app-body-right" align="justify">
            <router-view></router-view>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'AppBody',
    props: {
        content: String
    },
    data: function(){
        return{
            httpPath: ""
        };
    },
    created: function(){
        this.httpPath = this.$store.getters.httpPath;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .app-body-left{
        /*border: 3px solid #00F;*/
        padding: 0;
    }
    
    .app-body-right{
        /*border: 3px solid #00F;*/
        padding: 0;
        padding-left: 7pt;
    }
    
    #main-menu{
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
        /*background-image: url("/img/background.png");*/
    }

    #main-menu .nav-item{
        /*border-bottom: 1pt grey solid;*/
        border: 1pt #D8D8D8 solid;
        margin-bottom: 1px;
        
    }

    #main-menu .nav-item:hover{
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
    }

    #main-menu-hidden{
        /*box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);*/
        /*background-color: white;*/
        padding: 5pt;
        margin: 5pt;
    }

    #main-menu-hidden .nav-item{
        box-shadow: 0.0pt 0.2pt 5px rgba(122,122,122,0.5);
        background-color: white;
        margin: 1px;
    }
    
    .navbar-nav .nav-link {
        padding-right: 0;
        padding-left: 5pt;
    }    
    
</style>

